// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2m1gK","location":"Header_location__3mmLZ"};